<template>
    <v-container grid-list-xl>
        <v-card :elevation="2" :loading="loading" :disabled="loading">
            <v-card-title>Tipo valor por indicador</v-card-title>
            <v-card-text>

                <v-card>
                    <v-card-title>
                        <v-layout wrap justify-space-between>
                            <v-flex md4 sm12>
                                Lista de Indicadores
                            </v-flex>
                            <v-flex md7 sm12>
                                <v-text-field v-model="search" append-icon="search" label="Buscar" single-line
                                    hide-details></v-text-field>

                            </v-flex>
                            <v-flex md1 sm12>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn class="mx-2" fab small color="primary" v-on="on"
                                            @click="LimpiarDatosExportar">
                                            <v-icon> fa-download </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Exportar</span>
                                </v-tooltip>

                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text v-if="gindicadores != null">
                        <v-data-table :headers="headerIndicador" v-model="IndicadorSelected" :items="gindicadores"
                            class="elevation-1" :search="search" :no-data-text="gnodata" :no-results-text="gnosearch"
                            :items-per-page="3" item-key="codigo" show-select :single-select="singleSelect">
                        </v-data-table>
                    </v-card-text>
                </v-card>

                <v-layout wrap justify-space-between>
                    <v-flex md7 sm12>

                        <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left"
                            background-color="blue-grey lighten-4" v-if="IndicadorSelected.length > 0">
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab> <v-icon left>dialpad</v-icon> Datos </v-tab>
                            <v-tab v-show="TipovalorSelected.length > 0">
                                <v-icon left>fa-glasses</v-icon>Auditoría
                            </v-tab>
                            <v-tab-item>
                                <v-card v-if="IndicadorSelected.length > 0">
                                    <v-card-text>
                                        <v-data-table :headers="headerTipoValor" v-model="TipovalorSelected"
                                            :items="gindicadortipovalor" class="elevation-1" :no-data-text="gnodata"
                                            :items-per-page="20" item-key="idtipovalor" show-select
                                            :single-select="singleSelect">
                                            <template v-slot:top>
                                                <v-toolbar>
                                                    <v-toolbar-title>Tipos Valor de Indicador {{ IndicadorSelected[0].codigo
                                                    }}
                                                    </v-toolbar-title>
                                                    <v-divider class="mx-4" inset vertical></v-divider>
                                                    <v-spacer></v-spacer>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn icon x-large v-on="on" @click="nuevotipovalor">
                                                                <v-icon color="primary">add</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Agregar</span>
                                                    </v-tooltip>
                                                </v-toolbar>
                                            </template>
                                            <template v-slot:[`item.action`]="{ item }">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on" small class="mr-2" @click="EditarTipoValor(item)"
                                                            v-scroll-to="'#containera'">edit</v-icon>
                                                    </template>
                                                    <span>Editar</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on" small class="mr-2"
                                                            @click="Cambiarestadotipovalor(item)"
                                                            v-scroll-to="'#containera'">fa-check-circle</v-icon>
                                                    </template>
                                                    <span>Cambiar estado</span>
                                                </v-tooltip>

                                            </template>
                                            <template v-slot:item.activo="{ item }">
                                                <v-simple-checkbox v-model="item.activo" disabled></v-simple-checkbox>
                                            </template>
                                            <template v-slot:item.principal="{ item }">
                                                <v-simple-checkbox v-model="item.principal" disabled></v-simple-checkbox>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item v-if="TipovalorSelected.length > 0">
                                <auditoriasoportes :idtabla="24" :idregistro="TipovalorSelected[0].idindicadortipovalor">
                                </auditoriasoportes>
                            </v-tab-item>
                        </v-tabs>


                    </v-flex>
                    <v-flex md5 sm12>
                        <v-card v-if="TipovalorSelected.length > 0">

                            <v-card-text>
                                <v-data-table :headers="headerDesagregaciones" :items="gTipovalorListadesagregacion"
                                    class="elevation-1" :no-data-text="gnodata" :items-per-page="20"
                                    item-key="idtipovalorlistadesagregaciones">
                                    <template v-slot:[`item.action`]="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-on="on" small class="mr-2" @click="Cambiarestado(item)"
                                                    v-scroll-to="'#containera'">fa-check-circle</v-icon>
                                            </template>
                                            <span>Cambiar estado</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:item.activo="{ item }">
                                        <v-simple-checkbox v-model="item.activo" disabled></v-simple-checkbox>
                                    </template>
                                    <template v-slot:top>
                                        <v-toolbar>
                                            <v-toolbar-title>Lista de desagregaciones</v-toolbar-title>
                                            <v-divider class="mx-4" inset vertical></v-divider>
                                            <v-spacer></v-spacer>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon x-large v-on="on" @click="newdesagregacion">
                                                        <v-icon color="primary">add</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Agregar</span>
                                            </v-tooltip>
                                        </v-toolbar>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>

            </v-card-text>
        </v-card>
        <v-snackbar v-model="snack1" :timeout="8000" :color="MesaggeInfo.color">
            {{ this.MesaggeInfo.mensajeRespuesta }} {{ this.MesaggeInfo.codigoRespuesta }}
            <v-btn text @click="snack1 = false">Cerrar</v-btn>
        </v-snackbar>

        <v-dialog v-model="dialogdesagregacion" max-width="900px">
            <v-card>
                <v-card-title> Desagregaciones </v-card-title>
                <v-card-text>
                    <v-layout wrap justify-space-between>
                        <v-flex md6 sm12>
                            Territorial
                            <v-data-table :headers="headerDesagregacionesLista" :items="DesagregacionesTerritoriales"
                                class="elevation-1 mr-4" :no-data-text="gnodata" :items-per-page="20" show-select
                                :single-select="!singleSelect" item-key="iddesagregacion" v-model="D_TerritorialSelected">
                            </v-data-table>

                        </v-flex>
                        <v-flex md6 sm12>
                            Poblacional
                            <v-data-table :headers="headerDesagregacionesLista" :items="DesagregacionesPoblacionales"
                                class="elevation-1 mr-4" :no-data-text="gnodata" :items-per-page="20" show-select
                                :single-select="!singleSelect" item-key="iddesagregacion" v-model="D_PoblacionalSelected">
                            </v-data-table>
                        </v-flex>

                    </v-layout>

                </v-card-text>
                <v-card-actions>
                    <v-btn color="blue darken-1" @click="dialogdesagregacion = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" @click="AgregarDesagregacion">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="dialogtipovalor" max-width="800px">


            <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left"
                    background-color="blue-grey lighten-4" v-if="IndicadorSelected.length > 0">
                <v-tabs-slider></v-tabs-slider>
                    <v-tab> <v-icon left>dialpad</v-icon> Datos </v-tab>
                    <v-tab v-show="Indextipovalor >= 0">
                        <v-icon left>fa-glasses</v-icon>Auditoría
                    </v-tab>
                    <v-tab-item>
                        <v-card v-if="IndicadorSelected.length > 0">
                            <v-card-title> Indicador {{ IndicadorSelected[0].codigo }} </v-card-title>
                            <v-card-text>
                                <v-layout justify-space-between>
                                    <v-flex md9 sm12>
                                        <v-text-field v-model="NewTipoValor.nombreTipoValor" label="Nombre tipo valor" single-line
                                            hide-details>
                                        </v-text-field>

                                    </v-flex>
                                    <v-flex md3 sm12>
                                        <v-checkbox v-model="NewTipoValor.principal" label="Principal"
                                            :disabled="gindicadortipovalor.filter(p => p.principal == true).length > 0"></v-checkbox>
                                    </v-flex>
                                </v-layout>

                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="blue darken-1" @click="dialogtipovalor = false">Cancelar</v-btn>
                                <v-btn color="blue darken-1" @click="AgregartipoValor">Guardar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item v-if="Indextipovalor >= 0">
                        <auditoriasoportes :idtabla="25" :idregistro="NewTipoValor.idtipovalor">
                        </auditoriasoportes>
                        
                    </v-tab-item>
                </v-tabs>
            
        </v-dialog>

        <v-dialog v-model="dialogExportar" max-width="1000px">
            <v-card v-if="gindicadores != null">
                <v-card-title> Seleccione los elementos a exportar </v-card-title>
                <v-card-text v-if="gindicadores.length > 0">
                    <v-data-table :headers="headerIndicador" v-model="IndicadorExportar" :items="gindicadores"
                        class="elevation-1" :search="search" :no-data-text="gnodata" :no-results-text="gnosearch"
                        :items-per-page="3" item-key="idindicador" show-select :single-select="!singleSelect">
                    </v-data-table>
                    <v-flex md12 sm12>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn block class="mx-2" color="primary" v-on="on" @click="CargarDatosExportar">
                                    Listar los indicadores seleccionados
                                </v-btn>
                            </template>
                            <span>Listar</span>
                        </v-tooltip>
                    </v-flex>


                    <v-data-table :headers="headerDesagregacionesExportar" :items="gTipovalorListadesagregacionExportar"
                        class="elevation-1" :search="search" :no-data-text="gnodata" :no-results-text="gnosearch"
                        :items-per-page="10" item-key="idtipovalorlistadesagregaciones">
                        <template v-slot:footer>
                            <div id="div1" style="width: 100%; align: right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <download-excel id="div2" style="width: 100%; text-align: right"
                                            v-show="gTipovalorListadesagregacionExportar.length > 0" class="btn btn-default"
                                            :data="gTipovalorListadesagregacionExportar" :exportFields="exportable"
                                            name="nacionales.xls" type="xls" worksheet="Información">
                                            <v-icon color="secondary" v-on="on" large
                                                elevation="2">mdi-file-download-outline</v-icon>
                                        </download-excel>
                                    </template>
                                    <span>Descargar</span>
                                </v-tooltip>
                            </div>
                        </template>




                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="blue darken-1" @click="dialogExportar = false">Cerrar</v-btn>
                    <v-btn color="blue darken-1" @click="LimpiarDatosExportar">Limpiar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import auditoriasoportes from "../../components/content/auditoriasoportes";
export default {
    name: "TipovalorIndicador",
    data() {
        return {
            loading: false,
            snack1: false,
            MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
            search: "",
            IndicadorSelected: [],
            IndicadorExportar: [],
            TipovalorSelected: [],
            singleSelect: true,
            dialogdesagregacion: false,
            dialogtipovalor: false,
            dialogExportar: false,
            Indexdesagregacion: -1,
            Indextipovalor: -1,
            DesagregacionesTerritoriales: [],
            DesagregacionesPoblacionales: [],
            D_TerritorialSelected: [],
            D_PoblacionalSelected: [],
            NewDesagregaciontipovalor: [],
            NewIndicadorTipovalor: [],
            NewTipoValor: [],
            headerIndicador: [
                { text: "ID", value: "idindicador", align: " d-none" },
                { value: "codigo", text: "Codigo" },
                { value: "nombre", text: "Nombre" },
            ],
            headerTipoValor: [
                { text: "ID", value: "idtipovalor", align: " d-none" },
                { value: "nombreTipoValor", text: "Nombre" },
                { value: "principal", text: "Principal" },
                { value: "activo", text: "Estado" },
                { text: "Acción", value: "action", sortable: false, width: 80 },
            ],
            headerDesagregacionesExportar: [
                { text: "ID", value: "iddesagregacion", align: " d-none" },
                { value: "codigoindicador", text: "Indicador" },
                { value: "nombretipovalor", text: "TipoValor" },
                { value: "nombredesagregacion", text: "Desagregacion" },
                { value: "activo", text: "Estado Desagregacion" },
                { value: "estadotipovalor", text: "Estado Tipo Valor" },

            ],
            exportable: {
                ID: "iddesagregacion",
                CODIGO: "codigoindicador",
                TIPOVALOR: "nombretipovalor",
                DESAGREGACION: "nombredesagregacion",
                ESTADODESAGREGACION: "activo",
                ESTADOTIPOVALOR: "estadotipovalor"
            },
            headerDesagregaciones: [
                { text: "ID", value: "iddesagregacion", align: " d-none" },
                { value: "nombredesagregacion", text: "Nombre" },
                { value: "activo", text: "Estado" },
                { text: "Acción", value: "action", sortable: false, width: 50 },
            ],
            headerDesagregacionesLista: [
                { text: "ID", value: "iddesagregacion", align: " d-none" },
                { value: "nombre", text: "Nombre" },
                { value: "orden", text: "Orden" },
            ]
        };
    },
    components: {
        auditoriasoportes,
    },    
    methods: {
        ...mapActions([
            "get_indicadores", "get_tipovalorbyindicador", "get_desagregacionbytipovalor", "post_estadodesagregacion", "get_desagregacionesListado", "post_asignardesagregaciones", "post_CrearyAsignartipovalor", "post_estadotipovalor", "post_Actualizartipovalor", "get_desagregacionbytipovalorexportar", "get_porusuario"
        ]),
        cargardesagregaciones(idtipovalor) {
            this.get_desagregacionbytipovalor({ params: { idtipovalor: idtipovalor } });
        },
        Cambiarestado(elemento) {
            this.post_estadodesagregacion({ params: { idtipovalor: elemento.idtipovalor, iddesagregacion: elemento.iddesagregacion, state: !elemento.activo } });
            elemento.activo = !elemento.activo;
        },
        Cambiarestadotipovalor(elemento) {
            this.post_estadotipovalor({ params: { idtipovalor: elemento.idtipovalor, idindicador: elemento.idindicador, state: !elemento.activo } });
            elemento.activo = !elemento.activo;
        },
        newdesagregacion() {
            this.dialogdesagregacion = true;
            this.Indexdesagregacion = -1;
            this.D_TerritorialSelected = [];
            this.D_PoblacionalSelected = [];
        },
        nuevotipovalor() {
            this.dialogtipovalor = true;
            this.Indextipovalor = -1;
            this.NewTipoValor = {
                idindicador: this.IndicadorSelected[0].idindicador,
                idindicadortipovalor: 0,
                idtipovalor: -1,
                nombreTipoValor: '',
                principal: this.gindicadortipovalor.filter(p => p.principal == true).length == 0,
                activo: true
            }
        },
        AgregarDesagregacion() {
            this.NewDesagregaciontipovalor = []
            this.D_TerritorialSelected.forEach(element => {
                this.NewDesagregaciontipovalor.push({
                    activo: true,
                    iddesagregacion: element.iddesagregacion,
                    idtipovalor: this.TipovalorSelected[0].idtipovalor,
                    idtipovalorlistadesagregaciones: 0,
                }
                )
            });

            this.D_PoblacionalSelected.forEach(element => {
                this.NewDesagregaciontipovalor.push({
                    activo: true,
                    iddesagregacion: element.iddesagregacion,
                    idtipovalor: this.TipovalorSelected[0].idtipovalor,
                    idtipovalorlistadesagregaciones: 0,
                }
                )
            });

            this.loading = true;
            this.post_asignardesagregaciones({ data: this.NewDesagregaciontipovalor });
            this.NewDesagregaciontipovalor = []
            this.dialogdesagregacion = false;
        },
        AgregartipoValor() {
            this.loading = true;
            if (this.Indextipovalor >= 0) {
                this.post_Actualizartipovalor({ data: this.NewTipoValor });
            } else {
                this.post_CrearyAsignartipovalor({ data: this.NewTipoValor });
            }
            this.NewTipoValor = [];
            this.dialogtipovalor = false;
        },
        EditarTipoValor(item) {
            this.dialogtipovalor = true;
            this.Indextipovalor = this.gindicadortipovalor.indexOf(item);
            this.NewTipoValor = Object.assign({}, item);
        },
        CargarDatosExportar() {
            console.log('this.IndicadorExportar', this.IndicadorExportar)
            this.get_desagregacionbytipovalorexportar({ data: this.IndicadorExportar });
        },
        LimpiarDatosExportar() {
            this.dialogExportar = true;
            this.IndicadorExportar = [];
            this.get_desagregacionbytipovalorexportar({ data: null });
        }
    },
    computed: {
        ...mapGetters("mensaje", ["ginformation", "gnodata", "gnosearch"]),
        ...mapGetters(["gindicadores", "gindicadortipovalor", "gTipovalorListadesagregacion", "gdesagregacioneslista", "gTipovalorListadesagregacionExportar", "gopciones"]),
    },
    created() {
        this.get_indicadores();
        this.get_porusuario();
    },
    watch: {
        IndicadorSelected() {
            if (this.IndicadorSelected.length > 0) {
                this.get_tipovalorbyindicador({ params: { idindicador: this.IndicadorSelected[0].idindicador } });
                this.TipovalorSelected = [];
                if (this.gTipovalorListadesagregacion.length > 0) {
                    this.cargardesagregaciones(0);
                }

            }
        },
        TipovalorSelected() {
            if (this.TipovalorSelected.length > 0) {
                this.cargardesagregaciones(this.TipovalorSelected[0].idtipovalor)
                this.get_desagregacionesListado();
            } else {
                this.cargardesagregaciones(0);
            }
        },
        gTipovalorListadesagregacion() {
            this.DesagregacionesTerritoriales = []
            this.DesagregacionesPoblacionales = []
            if (this.gdesagregacioneslista.length > 0) {
                this.gdesagregacioneslista.forEach(element => {
                    if (element.territorial == true && this.gTipovalorListadesagregacion.filter(p => p.iddesagregacion == element.iddesagregacion).length == 0)
                        this.DesagregacionesTerritoriales.push(element)
                    if (element.poblacional == true && this.gTipovalorListadesagregacion.filter(p => p.iddesagregacion == element.iddesagregacion).length == 0)
                        this.DesagregacionesPoblacionales.push(element)
                });
            }
        },
        ginformation() {
            if (this.loading) {
                this.MesaggeInfo = this.ginformation;
                this.snack1 = true;
                this.buttontext = "aceptar";
                console.log(this.MesaggeInfo.mensajeRespuesta);
                this.loading = false;
            }
        }
    }
};
</script>

